import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";

const PRIMARY = "#E5A325";
const BG = "hsl(220, 20%, 7%)";
const BG_CARD = "hsl(220, 18%, 10%)";
const TEXT = "#e6e0d4";
const TEXT_MUTED = "#808090";
const GLASS_BORDER = "hsla(220, 15%, 25%, 0.5)";
const GRADIENT_CTA = `linear-gradient(135deg, ${PRIMARY}, #d4922a)`;
const FONT_DISPLAY = "'Space Grotesk', 'Inter', sans-serif";
const FONT_BODY = "'Inter', sans-serif";

const VerifyEmail = () => {
    document.title = "Verificar E-mail | Oplena";

    const [searchParams] = useSearchParams();
    const token = searchParams.get("token") || "";
    const email = searchParams.get("email") || "";

    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!token || !email) {
            setError("Link de verificação inválido.");
            setLoading(false);
            return;
        }

        fetch(`${process.env.REACT_APP_URL_API}auth/verify-email?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`)
            .then(res => res.json())
            .then(data => {
                if (data.code === 200) {
                    setSuccess(true);
                } else {
                    setError(data.message || "Erro ao verificar e-mail.");
                }
            })
            .catch(() => setError("Erro de conexão."))
            .finally(() => setLoading(false));
    }, [token, email]);

    return (
        <div style={{
            minHeight: "100vh", background: BG,
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: 20, fontFamily: FONT_BODY,
        }}>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Space+Grotesk:wght@400;500;600;700&display=swap');
            `}</style>

            <div style={{
                width: "100%", maxWidth: 480, background: BG_CARD, borderRadius: 24,
                boxShadow: "0 8px 32px hsla(0,0%,0%,0.4)", border: `1px solid ${GLASS_BORDER}`,
                padding: "48px 40px", textAlign: "center", position: "relative", overflow: "hidden",
            }}>
                <div style={{ position: "absolute", top: -60, right: -60, width: 200, height: 200, borderRadius: "50%", background: "radial-gradient(circle, hsla(43,96%,56%,0.08) 0%, transparent 70%)", pointerEvents: "none" }} />

                <div style={{ display: "inline-flex", alignItems: "center", gap: 12, marginBottom: 32 }}>
                    <img src="/logo.png" alt="Oplena" style={{ width: 56, height: 56, display: "inline-block" }} />
                    <span style={{ fontFamily: FONT_DISPLAY, fontSize: "1.6rem", fontWeight: 700, color: TEXT, letterSpacing: "-0.01em" }}>
                        Oplena
                    </span>
                </div>

                {loading ? (
                    <div>
                        <div style={{ marginBottom: 20 }}>
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke={TEXT_MUTED} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" style={{ animation: "spin 1.2s linear infinite" }}>
                                <circle cx="12" cy="12" r="9" opacity="0.25" />
                                <path d="M21 12a9 9 0 0 0-9-9" />
                            </svg>
                            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                        </div>
                        <h2 style={{ fontFamily: FONT_DISPLAY, color: TEXT, fontSize: "1.3rem", fontWeight: 700 }}>
                            Verificando seu e-mail
                        </h2>
                        <p style={{ color: TEXT_MUTED, fontSize: "0.9rem" }}>Aguarde um momento.</p>
                    </div>
                ) : success ? (
                    <div>
                        <div style={{ marginBottom: 20 }}>
                            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke={TEXT} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="9" opacity="0.4" />
                                <path d="M8 12.5l2.8 2.8L16.5 9.5" />
                            </svg>
                        </div>
                        <h2 style={{ fontFamily: FONT_DISPLAY, color: TEXT, fontSize: "1.3rem", fontWeight: 700, marginBottom: 8 }}>
                            E-mail verificado
                        </h2>
                        <p style={{ color: TEXT_MUTED, fontSize: "0.9rem", marginBottom: 32 }}>
                            Sua conta está ativa. Você já pode fazer login.
                        </p>
                        <Link to="/login" style={{
                            display: "inline-block", padding: "14px 48px", borderRadius: 14,
                            background: GRADIENT_CTA, color: BG, fontWeight: 700, fontSize: "1rem",
                            textDecoration: "none", boxShadow: "0 4px 20px hsla(43,96%,56%,0.25)",
                        }}>
                            Ir para o Login
                        </Link>
                    </div>
                ) : (
                    <div>
                        <div style={{ marginBottom: 20 }}>
                            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke={TEXT_MUTED} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="9" opacity="0.4" />
                                <path d="M9 9l6 6M15 9l-6 6" />
                            </svg>
                        </div>
                        <h2 style={{ fontFamily: FONT_DISPLAY, color: TEXT, fontSize: "1.3rem", fontWeight: 700, marginBottom: 8 }}>
                            Verificação falhou
                        </h2>
                        <p style={{ color: TEXT_MUTED, fontSize: "0.9rem", marginBottom: 32 }}>
                            {error}
                        </p>
                        <Link to="/login" style={{
                            display: "inline-block", padding: "14px 48px", borderRadius: 14,
                            background: GRADIENT_CTA, color: BG, fontWeight: 700, fontSize: "1rem",
                            textDecoration: "none", boxShadow: "0 4px 20px hsla(43,96%,56%,0.25)",
                        }}>
                            Voltar ao Login
                        </Link>
                    </div>
                )}

                <div style={{ marginTop: 32, color: TEXT_MUTED, fontSize: "0.75rem" }}>
                    © {new Date().getFullYear()} Oplena. Todos os direitos reservados.
                </div>
            </div>
        </div>
    );
};

export default VerifyEmail;
